import Behaviour, { mix, DomEvents } from '@/core'
// import resizer from 'spon-resize'
import VanillaModal from 'vanilla-modal'
import Slide from './components/Slide'
// import { lock } from '@/core/utils'
import { h, render } from 'preact' // eslint-disable-line

export default class PhotoGallery extends mix(Behaviour).with(DomEvents) {
	constructor(el) {
		super(el)

		/*
      This function must be called to bind the events
    */
		this.addDomEvents()
	}

	events = {
		'click [data-gallery-launcher]': 'onClick'
	}

	onClick = (e, elm) => {
		e.preventDefault()
		const href = elm.getAttribute('href')
		const { meta } = elm.dataset
		this.data = JSON.parse(meta)
		this.modal.open(href)
	}

	mounted = () => {
		this.data = {}
		this.$content = document.getElementById('modal-content')

		this.modal = new VanillaModal({
			modal: '.modal',
			modalInner: '.modal__inner',
			modalContent: '.modal__content',
			open: '[data-modal-open]',
			close: '[data-modal-close]',
			page: 'body',
			loadClass: 'vanilla-modal',
			class: 'modal--visible',
			clickOutside: true,
			closeKeys: [27],
			transitions: true,
			onBeforeOpen: null,
			onBeforeClose: () => {
				this.$content, () => { }
				this.modal.dom.modal.dataset.modalType = ''
			},
			onOpen: () => {
				this.render(this.data, this.$content)
				// this.modal.dom.dataset.type = 'photo-gallery'
				this.modal.dom.modal.dataset.modalType = 'photo-gallery'
				// this.lock.capture()
			},
			onClose: () => {
				this.$content
				// this.lock.release()
			}
		})
	}

	render = (data, $target) => {
		render(
			<div className="photo-gallery">

				<div class="text-center photo-gallery__information-wrapper">

					<div className={'photo-gallery__meta meta ' + (data.categoryKebab ? 't-' + data.categoryKebab : '')}>
						<span className="meta__diamond t-color">
							<i class="icon icon--diamond">
								<svg>
									<use
										className="no-barba"
										xmlnsXlink="http://www.w3.org/1999/xlink"
										xlinkHref="#diamond"
									/>
								</svg>
							</i>
						</span>
						<span className="meta__date">{data.datePosted}</span>
						<span className="meta__line" />
						<span className="meta__category">
							{data.category ? data.category : ''}
						</span>
					</div>
					<h2 className="h2">{data.title}</h2>

				</div>

				<div className="photo-gallery__images slide">
					<Slide images={data.gallery} />
				</div>
			</div>,
			$target,
			$target.lastChild
		)
	}

	unmount = () => {
		this.modal.destroy()
	}
}
